import { useLocation } from "react-router-dom";
import { useJobSetupStore } from "@presentation/stores/JobSetupStore";
import { JobPipelineTypeSchema } from "@domain/schemas/BI";
import { getVisibleRightPanelTabKeys, RightPanelTabKey } from "./rightPanelTabs";

/**
Resolves `tabKey`'s current position among the visible Data Explorer tabs, so a form block can
switch to it via `setRightPanelTab` without hardcoding an index that only happens to be correct
for today's particular combination of visible tabs.
*/
export const useRightPanelTabIndex = (tabKey: RightPanelTabKey, isAdvancedSettingsExpanded = false): number => {
  const location = useLocation();
  const pipelineType = useJobSetupStore((state) => state.CreateJobState.pipelineType ?? JobPipelineTypeSchema.DirectDIA);
  const resumeFromStepId = useJobSetupStore((state) => state.CreateJobState.resumeFromStepId);
  const software = useJobSetupStore((state) => state.CreateJobState.software);
  const isRerunMode = new URLSearchParams(location.search).has("rerunJobId");
  const index = getVisibleRightPanelTabKeys(pipelineType, resumeFromStepId, isRerunMode, software, isAdvancedSettingsExpanded).indexOf(tabKey);
  return index === -1 ? 0 : index;
};
